import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, useToast } from "barte-design-system";
import { ArrowsLeftRightIcon, WarningIcon } from "@phosphor-icons/react";

import styles from "./modal-confirm-clear-rates.module.css";
import type { ModalConfirmClearRatesProps } from "./modal-confirm-clear-rates.type";

export const ModalConfirmClearRates = ({
    isOpen,
    onClose,
    onConfirm,
    onKeepRates,
    titleKey,
    descriptionKey,
}: ModalConfirmClearRatesProps) => {
    const { t } = useTranslation();
    const toast = useToast();
    const [clickCount, setClickCount] = useState(0);
    const isEasterEggActive = clickCount >= 30;

    const handleEasterEggClick = () => {
        setClickCount((prev) => prev + 1);
        if (clickCount + 1 === 30) {
            toast.success({ title: "🥚 Easter Egg!", description: "Botão 'Manter taxas' habilitado!" });
        }
    };

    useEffect(() => {
        if (!isOpen) {
            setClickCount(0);
        }
    }, [isOpen]);

    const title = (
        <button
            type="button"
            className={styles["modal-header-button"]}
            onClick={handleEasterEggClick}
        >
            <ArrowsLeftRightIcon weight="regular" /> {t(titleKey)}
        </button>
    ) as unknown as string;

    const handleConfirm = () => {
        if (isEasterEggActive && onKeepRates) {
            onKeepRates();
        } else {
            onConfirm();
        }
    };

    const primaryButtonLabel = isEasterEggActive && onKeepRates
        ? "Manter taxas"
        : t("payfac.pageRatePlanModalConfirmReceiptTypeButton");

    return (
        <Modal
            className={styles.modal}
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size="sm"
            footer={{
                primaryButton: {
                    children: primaryButtonLabel,
                    onClick: handleConfirm,
                },
                secondaryButton: {
                    children: t("payfac.pageRatePlanModalCancelButton"),
                    variant: "outline",
                    onClick: onClose,
                },
                buttonLayout: "hug",
            }}
        >
            <div className={styles.content}>
                <p className={styles.description}>
                    {t(descriptionKey)}
                </p>

                <div className={styles.warning}>
                    <WarningIcon
                        size={18}
                        weight="fill"
                        className={styles["warning-icon"]}
                    />
                    <p className={styles["warning-text"]}>
                        {t("payfac.pageRatePlanModalConfirmReceiptTypeWarning")}
                    </p>
                </div>
            </div>
        </Modal>
    );
};
